import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-186bbba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ODetalhesEventoPlanejado__Cabecalho",
  "data-testid": "ODetalhesEventoPlanejado__Cabecalho"
}
const _hoisted_2 = { class: "ODetalhesEventoPlanejado__Titulo ajustar-textos-longos" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-lock Icone--travado"
}
const _hoisted_4 = { class: "ODetalhesEventoPlanejado__Acoes" }
const _hoisted_5 = {
  class: "ODetalhesEventoPlanejado__Conteudo",
  "data-testid": "ODetalhesEventoPlanejado__Conteudo"
}
const _hoisted_6 = {
  key: 0,
  class: "ODetalhesEventoPlanejado__Etapas",
  "data-testid": "ODetalhesEventoPlanejado__Etapas"
}
const _hoisted_7 = {
  key: 1,
  class: "ODetalhesEventoPlanejado__SemAtributos",
  "data-testid": "ODetalhesEventoPlanejado__SemAtributos"
}
const _hoisted_8 = { class: "ODetalhesEventoPlanejado__Profissionais" }
const _hoisted_9 = {
  key: 0,
  class: "ODetalhesEventoPlanejado__Icone Icone--info pi pi-user"
}
const _hoisted_10 = {
  key: 0,
  class: "ODetalhesEventoPlanejado__PeriodosEIcone"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "ODetalhesEventoPlanejado__Icone Icone--info pi pi-clock" }, null, -1))
const _hoisted_12 = { class: "ODetalhesEventoPlanejado__PeriodoDuplo" }
const _hoisted_13 = {
  key: 1,
  class: "ODetalhesEventoPlanejado__Periodo"
}
const _hoisted_14 = {
  key: 0,
  class: "ODetalhesEventoPlanejado__Projeto",
  "data-testid": "ODetalhesEventoPlanejado__Projeto"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "ODetalhesEventoPlanejado__Icone Icone--info pi pi-map" }, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "ODetalhesEventoPlanejado__ComAtributos"
}

import { Anulavel, EntidadeGenerica } from "@/types/gerais"
  import Dialog from "primevue/dialog"
  import {
    computed,
    onBeforeMount,
    ref,
    reactive,
    ComputedRef,
    watch,
    onUnmounted
  } from "vue"
  import {
    MModalSeletorRadio,
    IAlertaMensagem,
    AEtapas
  } from "@/components/Gerais"
  import { MFormularioAtividadeComAtributos } from "@/components/Atributos"
  import { Etapa } from "@/components/Gerais/AEtapas/AEtapas.modelos"
  import {
    MEventoPeriodo,
    OListaDeProfissionais,
    ABotaoDeAcao,
  } from "@/components/Calendario"
  import { estados } from "@/types/api"
  import SessaoServico from "@/servicos/sessao.service"
  import {
    ParamsProjeto,
    ProjetosSimples,
  } from "@/repositorios/projeto/projeto.modelo"
  import ProjetoRepositorio from "@/repositorios/projeto/projeto.repositorio"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import {
    CalendariosParams,
    ListarCalendariosDasAtividades,
    EditarCalendarioDaAtividade
  } from "@/repositorios/calendarios/calendarios.modelos"
  import CalendariosDasAtividadesRepositorio from "@/repositorios/calendarios/calendarios.repositorio"
  import AtividadesPlanejadasRepositorio from "@/repositorios/eventos/eventos.repositorio"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { FasesDaAtividade } from "@/repositorios/atividades/atividades.modelos"
  import { useI18n } from "vue-i18n"
  import { AtividadePlanejadaSimples, ParametrosAtividadePlanejada } from "@/repositorios/eventos/eventos.modelo"
  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"
  import { storeToRefs } from "pinia"
  import { CaracteristicaComValor } from "@/components/AtributoComValor"
  import { AtributoBase } from "@/repositorios/atributos/atributos.modelos"
  import { usarPermissionamento } from "@/composable/UsarPermissionamento"
  
  interface Props {
    fim: Date
    inicio: Date
    inicioPlanejado?: Anulavel<Date>
    fimPlanejado?: Anulavel<Date>
    profissionais: EntidadeGenerica[]
    projetoId: Anulavel<string>
    eventoId: string
    calendarioId?: Anulavel<string>
    nomeAtividade: string
    atributosEsperados?: AtributoBase[]
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    duracaoEmMinutos: number
    nomeProjeto: Anulavel<string>
    atividadeRecorrente: Anulavel<boolean>
    teleportarPara?: string
    visibilidade: boolean
    faseDaAtividade: FasesDaAtividade
    acaoIniciandoOuFinalizandoAtividade: boolean
  }

  interface AlertaComReset extends IAlertaMensagem {
    $reset(): void
  }

  type ModoDeDelecao =
    | "deletar-somente-esta-atividade"
    | "deletar-esta-atividade-e-as-seguintes"
    | "deletar-todas-as-atividades"

  interface OpcaoDeDelecao {
    nome: string;
    chave: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODetalhesEventoPlanejado',
  props: {
    fim: null,
    inicio: null,
    inicioPlanejado: null,
    fimPlanejado: null,
    profissionais: null,
    projetoId: null,
    eventoId: null,
    calendarioId: null,
    nomeAtividade: null,
    atributosEsperados: null,
    listaDeAtributosCaracteristicaComValor: null,
    duracaoEmMinutos: null,
    nomeProjeto: null,
    atividadeRecorrente: null,
    teleportarPara: null,
    visibilidade: { type: Boolean },
    faseDaAtividade: null,
    acaoIniciandoOuFinalizandoAtividade: { type: Boolean }
  },
  emits: ["update:visibilidade", "aoExibirModalDeEdicaoPlanejamento", "onRecarregarAtividades", "iniciarAtividade", "finalizarAtividade"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:visibilidade", visibilidade: boolean): void
    (event: "aoExibirModalDeEdicaoPlanejamento"): void
    (event: "onRecarregarAtividades"): void
    (event: "iniciarAtividade"): void
    (event: "finalizarAtividade"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    fim: Date
    inicio: Date
    inicioPlanejado?: Anulavel<Date>
    fimPlanejado?: Anulavel<Date>
    profissionais: EntidadeGenerica[]
    projetoId: Anulavel<string>
    eventoId: string
    calendarioId?: Anulavel<string>
    nomeAtividade: string
    atributosEsperados?: AtributoBase[]
    listaDeAtributosCaracteristicaComValor?: CaracteristicaComValor[]
    duracaoEmMinutos: number
    nomeProjeto: Anulavel<string>
    atividadeRecorrente: Anulavel<boolean>
    teleportarPara?: string
    visibilidade: boolean
    faseDaAtividade: FasesDaAtividade
    acaoIniciandoOuFinalizandoAtividade: boolean
  }

  

  const { t } = useI18n()

  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas } = storeToRefs(caracteristicaStore)
  const { resolverLeitor, leitor } = usarLeitorDeDados()
  const { escritor, resolver } = usarEscritorDeDados()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const { verificarSeElementoTemConteudo } = usarManipuladorObjetos()
  const {
    pegarSomenteData,
    verificarSeDataEhMenorOuIgualQue,
    aplicarTimezoneEmHorasMinutos,
    pegarSomenteAsHoras,
    pegarDataDeHoje,
    ehPrimeiroEventoDoCalendario,
    pegarHorasMinutosSegundos
  } = usarDataHora()

  const projetoRep = new ProjetoRepositorio()
  const calendariosRep = new CalendariosDasAtividadesRepositorio()
  const atividadesPlanejadasRep = new AtividadesPlanejadasRepositorio()

  const lerEventosPlanejados = leitor<AtividadePlanejadaSimples, ParametrosAtividadePlanejada>(
    atividadesPlanejadasRep.listarAtividadesPlanejadas,
    {}
  )

  const lerProjetos = leitor<ProjetosSimples, ParamsProjeto>(
    projetoRep.listarProjetos,
    {}
  )
  const lerCalendarios = leitor<
    ListarCalendariosDasAtividades,
    CalendariosParams
  >(calendariosRep.listarCalendariosDaAtividade)

  const escritorDeletarEventoPlanejadoEscritor = escritor<
    { id: string },
    string,
    undefined
  >(atividadesPlanejadasRep.deletarAtividadePlanejada, [])

  const escritorDeletarCalendarioDaAtividade = escritor<
    { id: string },
    string,
    undefined
  >(calendariosRep.deletarCalendarioDaAtividade, [])

  const escritorEditarCalendarioDaAtividade = escritor<
    { id: string },
    string,
    EditarCalendarioDaAtividade
  >(calendariosRep.editarCalendariosDasAtividades, [])
  const dataInicioEhMenorOuIgualHoje = ref(false)
  const calendarioDaAtividade = ref<ListarCalendariosDasAtividades>()
  const usuarioEhResponsavel = ref(false)
  const ehEventoTravado = ref(false)
  const ultimoEventoCalendario = ref<AtividadePlanejadaSimples>()
  const estaIniciandoOuFinalizandoAtividade = ref(false)
  const modalDeDelecaoEstaVisivel = ref(false)
  const estaDeletandoAtividade = ref<number>(estados.INICIAL)
  const estaBuscandoCalendario = ref<number>(estados.INICIAL)

  const etapas = <Etapa[]>([
    { rotulo: t('etapaAtividade') },
    { rotulo: t('etapaAtributos') }
  ])

  const etapaAtiva = ref<number>(0)

  const aoClicarNaEtapa = (indice: number) => {
    etapaAtiva.value = indice
  }

  

  const emitirVisibilidade = computed({
    get() {
      return props.visibilidade
    },
    set(visibilidade: boolean) {
      emitir("update:visibilidade", visibilidade)
    },
  })

  let dadosDoAlerta = reactive<AlertaComReset>({
    titulo: "",
    icone: "",
    visivel: false,
    conteudo: "",
    tipo: "padrao",
    $reset: function () {
      this.visivel = false
      this.titulo = ""
      this.icone = ""
      this.conteudo = ""
    },
  })

  const { id: idUsuarioLogado } =
    SessaoServico.coletarInformacoesDoUsuarioLogado()
  const { verificarPermissao: permissaoEventos } = usarPermissionamento("Eventos")

  const { id: idProfissionalUsuarioLogado } =
    SessaoServico.coletarInformacoesDeProfissionalDoUsuario()

  const buscarDadosDoProjeto = async (projetoId: string): Promise<void> => {
    const resolverDados = (dados: ProjetosSimples[]): void => {
      const usuariosResponsaveis = dados[0].usuariosResponsaveis
      usuarioEhResponsavel.value =
        usuariosResponsaveis.includes(idUsuarioLogado)
    }

    lerProjetos.sobrescreverParametros({
      id: `igual.${projetoId}`,
    })

    await lerProjetos.executar()

    resolverLeitor<ProjetosSimples>(lerProjetos.resultado, {
      sucesso: resolverDados,
    })
  }

  const eventoPossuiDataEHoraNoPassado = computed(() => {
    const dataInicioEvento = pegarSomenteData(props.inicio)
    const horaInicioEvento = pegarHorasMinutosSegundos(props.inicio)
    const dataHoje = pegarSomenteData(pegarDataDeHoje())
    const horarioAtual = pegarSomenteAsHoras(pegarDataDeHoje())

    return (dataInicioEvento < dataHoje) || (dataInicioEvento === dataHoje && horaInicioEvento < horarioAtual)
  })

  const usuarioTemPermissaoParaEditarDeletar = computed(() => {
    return (
      permissaoEventos("editar") ||
      (usuarioEhResponsavel.value && props.projetoId)
    )
  })

  const podeEditarDeletarOEvento = computed(() => {
    return (
      usuarioTemPermissaoParaEditarDeletar.value &&
      !eventoPossuiDataEHoraNoPassado.value
    )
  })

  const profissionalLogadoEstaAlocado = computed(() => {
    return props.profissionais.find(
      (profissional) => profissional.id === idProfissionalUsuarioLogado
    )
  })

  const deveMostrarBotaoDeIniciarAtividadePlanejada = computed(() => {
    return atividadePossuiAtributos.value && etapaAtiva.value === 0 && props.faseDaAtividade !== "emAndamento"
  })

  const deveDesabilitarCamposDeAtributos = computed(() => {
    return (
      props.faseDaAtividade === "naoPodeIniciar" || 
      props.faseDaAtividade === "finalizada"
    )
  })

  const deveMostrarPeriodoPlanejado = computed(() => {
    const fasesQueNaoDeveMostrar: FasesDaAtividade[] = [
      "naoPodeIniciar",
      "finalizada",
      "podeSerIniciada",
    ]

    const eventoPossuiProfissional = props.profissionais.length > 0
    if (!eventoPossuiProfissional || ehEventoTravado.value) {
      return false
    }

    const usuarioTemPermissaoDeVisualizarPeriodo = profissionalLogadoEstaAlocado.value
    const atividadePodeSerIniciada = !fasesQueNaoDeveMostrar.includes(props.faseDaAtividade)

    return atividadePodeSerIniciada && usuarioTemPermissaoDeVisualizarPeriodo
  })

  const deveMostrarBotaoDeAtividade = computed(() => {
    const fasesQueNaoDeveMostrar: FasesDaAtividade[] = ["naoPodeIniciar", "finalizada"]
    const eventoPossuiProfissional = props.profissionais.length > 0

    if (!eventoPossuiProfissional || ehEventoTravado.value) {
      return false
    }

    const usuarioTemPermissaoDeVisualizarBotao = profissionalLogadoEstaAlocado.value
    const atividadePodeSerIniciada = !fasesQueNaoDeveMostrar.includes(props.faseDaAtividade)

    return atividadePodeSerIniciada && usuarioTemPermissaoDeVisualizarBotao
  }) as ComputedRef<boolean>

  const desabilitarBotaoIniciarAtividade = computed(() => {
    return !caracteristicas.value.every(caracteristica => verificarSeElementoTemConteudo(caracteristica.valor))
  })

  const abrirModalDeEdicaoPlanejamento = () => {
    emitir("aoExibirModalDeEdicaoPlanejamento")
  }

  const finalizarAtividadePlanejada = (): void => {
    estaIniciandoOuFinalizandoAtividade.value = true
    emitir("finalizarAtividade")
  }

  const iniciarAtividadePlanejada = (): void => {
    estaIniciandoOuFinalizandoAtividade.value = true
    emitir("iniciarAtividade")
  }

  const totalDeProfissionais = computed((): number => {
    return props.profissionais.length
  })

  const possuiSomenteUmProfissional = computed((): boolean => {
    return totalDeProfissionais.value === 1
  })

  const atividadePossuiAtributos = computed((): boolean | undefined => {
    return (
      (props.atributosEsperados && props.atributosEsperados.length > 0) ||
      (props.listaDeAtributosCaracteristicaComValor && props.listaDeAtributosCaracteristicaComValor.length > 0)
    )
  })

  const deveExibirEtapas = computed((): boolean | undefined => {
    return atividadePossuiAtributos.value
  })

  const estiloNoModoDeAcao = computed((): boolean | string => {
    return (
      deveMostrarBotaoDeAtividade.value &&
      "ODetalhesEventoPlanejado--ModoDeAcao"
    )
  })

  const buscarUltimoEventoDoCalendario = async (
    calendarioId: string
  ): Promise<void> => {
    ultimoEventoCalendario.value = undefined

    lerEventosPlanejados.sobrescreverParametros({
      "calendario_que_criou_id": `igual.${calendarioId}`,
      "ordenar-por": "desc.data_inicio",
      "por-pagina": 1000
    })

    await lerEventosPlanejados.executar()

    resolverLeitor<AtividadePlanejadaSimples>(lerEventosPlanejados.resultado, {
      sucesso: async (dados) => {
        ultimoEventoCalendario.value = dados[0]
      },
      erro: () => {
        onErro({
          resumo: t("ocorreuUmErro"),
          detalhes: t("naoFoiPossívelAcessarOsEventosDoCalendario"),
        })
      }
    })
  }

  const carregarDadosDoCalendario = async (
    calendarioId: string
  ): Promise<void> => {
    estaBuscandoCalendario.value = estados.PEDENTE
    lerCalendarios.sobrescreverParametros({
      id: `igual.${calendarioId}`,
    })

    await lerCalendarios.executar()

    resolverLeitor<ListarCalendariosDasAtividades>(lerCalendarios.resultado, {
      sucesso: async (dados) => {
        calendarioDaAtividade.value = dados[0]
        dataInicioEhMenorOuIgualHoje.value = verificarSeDataEhMenorOuIgualQue(
          calendarioDaAtividade.value.dataInicial
        )
        estaBuscandoCalendario.value = estados.SUCESSO
      },
      erro: () => {
        onErro({
          resumo: t("ocorreuUmErro"),
          detalhes: t("naoPossivelBuscarOsDadosDoCalendarioDoEvento"),
        })
        estaBuscandoCalendario.value = estados.ERRO
        lidarComVisibilidadeModalDeDelecao(false)
      },
    })
  }

  const estaCarregandoDelecao = computed(() => {
    return estaDeletandoAtividade.value === estados.PEDENTE
  })

  const opcoesSeletorDeDelecao = computed(() => {
    const deletarSomenteEstaAtividade = {
      nome: t("deletarSomenteEstaAtividade"),
      chave: "deletar-somente-esta-atividade",
    }

    const deletarEstaAtividadeEAsSeguintes = {
      nome: t("deletarEstaAtividadeAsSeguintes"),
      chave: "deletar-esta-atividade-e-as-seguintes",
    }

    const deletarTodasAsAtividades = {
      nome: t("deletarTodasAsAtividades"),
      chave: "deletar-todas-as-atividades",
    }

    if (calendarioDaAtividade.value) {
      const dataHoje = pegarSomenteData(pegarDataDeHoje())
      const horarioAtual = pegarSomenteAsHoras(pegarDataDeHoje())

      const mapaDoCalendario = calendarioDaAtividade.value.mapaDoCalendario
      const dataInicioCalendario = calendarioDaAtividade.value.dataInicial
      const horaInicioCalendario = aplicarTimezoneEmHorasMinutos(calendarioDaAtividade.value.horarioDeInicio, -3)
      const dataFinalCalendario = calendarioDaAtividade.value.dataFinal

      const calendarioIniciaNoPassado = (dataInicioCalendario < dataHoje) ||
      (dataInicioCalendario === dataHoje && horaInicioCalendario < horarioAtual)

      const dataInicioEvento = pegarSomenteData(props.inicio)

      const eventoNoUltimoDiaDoCalendario = dataInicioEvento === ultimoEventoCalendario.value?.dataInicio
      const eventoAntesDoUltimoDiaDoCalendario = dataInicioEvento < dataFinalCalendario
      const eventoDepoisDoInicioDoCalendario = dataInicioEvento > dataInicioCalendario
      const eventoNoPrimeiroDiaDoCalendario = ehPrimeiroEventoDoCalendario(
        mapaDoCalendario,
        dataInicioCalendario,
        dataInicioEvento
      )

      const definirOpcoesParaCalendarioNoPassado = (): OpcaoDeDelecao[] | void  => {
        if (eventoNoUltimoDiaDoCalendario) {
          return [deletarSomenteEstaAtividade]
        }

        return [deletarSomenteEstaAtividade, deletarEstaAtividadeEAsSeguintes]
      }

      const definirOpcoesParaCalendarioNoFuturo = (): OpcaoDeDelecao[] | void  => {
        if (eventoNoPrimeiroDiaDoCalendario || eventoNoUltimoDiaDoCalendario) {
          return [
            deletarSomenteEstaAtividade,
            deletarTodasAsAtividades,
          ]
        } else if (eventoDepoisDoInicioDoCalendario && eventoAntesDoUltimoDiaDoCalendario) {
          return [
            deletarSomenteEstaAtividade,
            deletarEstaAtividadeEAsSeguintes,
            deletarTodasAsAtividades,
          ]
        }
      }

      if (calendarioIniciaNoPassado) {
        return definirOpcoesParaCalendarioNoPassado()
      } else {
        return definirOpcoesParaCalendarioNoFuturo()
      }
    }

    return [deletarSomenteEstaAtividade]
  })

  const lidarComQualModalDeAcaoDeveSerAberto = async (): Promise<void> => {
    const temCalendario = props.calendarioId

    if (temCalendario) {
      try {
        await Promise.all([
          buscarUltimoEventoDoCalendario(props.calendarioId),
          carregarDadosDoCalendario(props.calendarioId)
        ])

        lidarComVisibilidadeModalDeDelecao(true)
      } catch (e) {
        onErro({
          resumo: t("ocorreuUmErro"),
          detalhes: t("naoFoiPossivelCarregarOsDadosDoCalendario"),
        })
      }
    } else {
      lidarComVisibilidadeModalDeDelecao(true)
    }
  }

  const lidarComVisibilidadeModalDeDelecao = (visibilidade: boolean): void => {
    modalDeDelecaoEstaVisivel.value = visibilidade
  }


  const fecharModalDeConfirmacao = (): void => {
    dadosDoAlerta.visivel = false
  }

  const lidarComDelecaoAtividadePlanejada = async (
    modoDeDelecao: string
  ): Promise<void> => {
    const tipoDeRequisicao: {
      [key in ModoDeDelecao]: () => Promise<void>
    } = {
      "deletar-somente-esta-atividade": deletarSomenteEstaAtividade,
      "deletar-esta-atividade-e-as-seguintes": deletarEstaAtividadeEAsSeguintes,
      "deletar-todas-as-atividades": deletarTodasAsAtividades,
    }

    estaDeletandoAtividade.value = estados.PEDENTE

    await tipoDeRequisicao[modoDeDelecao]()

    setTimeout(() => {
      emitir("onRecarregarAtividades")
    }, 5000)
  }

  const deletarSomenteEstaAtividade = async (): Promise<void> => {
    estaDeletandoAtividade.value = estados.PEDENTE
    escritorDeletarEventoPlanejadoEscritor.mudarArgumentos([props.eventoId])
    await escritorDeletarEventoPlanejadoEscritor.executar()

    resolver(escritorDeletarEventoPlanejadoEscritor.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t("atividadePlanejadaFoiDeletada"),
          detalhes: t("calendarioEstaSendoAtualizado"),
        })
      },
      erro: () => {
        onErro({
          resumo: t("naoFoiPossivelDeletarAtividadePlanejada"),
          detalhes: "",
        })
      },
    })

    lidarComVisibilidadeModalDeDelecao(false)
    fecharModalDeConfirmacao()
    estaDeletandoAtividade.value = estados.SUCESSO
  }

  const deletarEstaAtividadeEAsSeguintes = async (): Promise<void> => {
    const formatarParametrosDoCalendarioDaAtividade = (
      calendario: ListarCalendariosDasAtividades
    ): EditarCalendarioDaAtividade => {
      const dataInicioDoEvento = new Date(props.inicio)

      const novaDataFimDoCalendario =
        dataAnteriorAoInicioDoEvento(dataInicioDoEvento)

      const { timezoneInicio, horarioDeInicio, mapaDoCalendario, profissionaisAlocados, duracaoEmMinutos,...parametrosSemMapaDoCalendario } = calendario

      const parametrosDoCalendarioDaAtividade: EditarCalendarioDaAtividade = {
        ...parametrosSemMapaDoCalendario,
        numeroDeDias: mapaDoCalendario.numeroDeDias,
        duracaoEmMinutos: duracaoEmMinutos ?? props.duracaoEmMinutos,
        horarioDeInicio: aplicarTimezoneEmHorasMinutos(horarioDeInicio, timezoneInicio),
        diasComAtividade: mapaDoCalendario.diasComAtividade,
        dataFinal: pegarSomenteData(novaDataFimDoCalendario),
        idsProfissionaisAlocados: profissionaisAlocados.map((profissional) => profissional.id) as string[],
      }

      return parametrosDoCalendarioDaAtividade
    }

    const dataAnteriorAoInicioDoEvento = (data: Date): Date => {
      return new Date(data.setDate(data.getDate() - 1))
    }

    estaDeletandoAtividade.value = estados.PEDENTE

    if (props.calendarioId && calendarioDaAtividade.value) {
      escritorEditarCalendarioDaAtividade.mudarArgumentos([
        props.calendarioId,
        formatarParametrosDoCalendarioDaAtividade(calendarioDaAtividade.value),
      ])

      await escritorEditarCalendarioDaAtividade.executar()

      resolver(escritorEditarCalendarioDaAtividade.resultado, {
        sucesso: () => {
          onSucesso({
            resumo: t("asAtividadesForamDeletadas"),
            detalhes: t("calendarioEstaSendoAtualizado"),
          })
        },
        erro: () => {
          onErro({
            resumo: t("naoFoiPossivelDeletarAsAtividades"),
            detalhes: "",
          })
        },
      })
    }

    lidarComVisibilidadeModalDeDelecao(false)
    estaDeletandoAtividade.value = estados.SUCESSO
  }

  const deletarTodasAsAtividades = async (): Promise<void> => {
    estaDeletandoAtividade.value = estados.PEDENTE

    escritorDeletarCalendarioDaAtividade.mudarArgumentos([props.calendarioId!])
    await escritorDeletarCalendarioDaAtividade.executar()

    resolver(escritorDeletarCalendarioDaAtividade.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t("asAtividadesForamDeletadas"),
          detalhes: t("calendarioEstaSendoAtualizado"),
        })
      },
      erro: () => {
        onErro({
          resumo: t("naoFoiPossivelDeletarTodasAsAtividades"),
          detalhes: "",
        })
      },
    })

    lidarComVisibilidadeModalDeDelecao(false)
    estaDeletandoAtividade.value = estados.SUCESSO
  }

  const avancarParaProximaEtapa = (): void => {
    etapaAtiva.value = 1
  }

  watch(
    () => props.acaoIniciandoOuFinalizandoAtividade,
    (estadoDeCarregamento: boolean) =>
      (estaIniciandoOuFinalizandoAtividade.value = estadoDeCarregamento)
  )

  onUnmounted(() => {
    caracteristicaStore.resetarCaracteristicas()
  })

  onBeforeMount(async () => {
    if (props.projetoId) {
      await buscarDadosDoProjeto(props.projetoId)
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Dialog), {
      visible: _unref(emitirVisibilidade),
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirVisibilidade) ? (emitirVisibilidade).value = $event : null)),
      "append-to": __props.teleportarPara,
      class: _normalizeClass(["ODetalhesEventoPlanejado", _unref(estiloNoModoDeAcao)]),
      "data-testid": "ODetalhesEventoPlanejado",
      "dismissable-mask": "",
      draggable: false,
      header: "Header",
      modal: true,
      style: { 'min-width': '550px' }
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, [
            (ehEventoTravado.value)
              ? (_openBlock(), _createElementBlock("em", _hoisted_3))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(__props.nomeAtividade), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_unref(podeEditarDeletarOEvento))
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 0,
                  onClick: abrirModalDeEdicaoPlanejamento,
                  class: "ODetalhesEventoPlanejado__Botao p-button-rounded p-button-sm",
                  "data-testid": "ODetalhesEventoPlanejado__Editar",
                  icon: "pi pi-pencil",
                  loading: _ctx.estaVerificandoPermissaoDeSupervisor
                }, null, 8, ["loading"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('editar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (_unref(podeEditarDeletarOEvento))
              ? _withDirectives((_openBlock(), _createBlock(_component_PButton, {
                  key: 1,
                  onClick: lidarComQualModalDeAcaoDeveSerAberto,
                  class: "ODetalhesEventoPlanejado__Botao p-button-rounded p-button-sm",
                  "data-testid": "ODetalhesEventoPlanejado__Excluir",
                  icon: "pi pi-trash",
                  loading: 
              (_ctx.estaVerificandoPermissaoDeSupervisor ||
                estaBuscandoCalendario.value === _unref(estados).PEDENTE)
            
                }, null, 8, ["loading"])), [
                  [
                    _directive_tooltip,
                    _unref(t)('deletar'),
                    void 0,
                    { top: true }
                  ]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_unref(deveExibirEtapas))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(AEtapas), {
                  onEtapaClicada: aoClicarNaEtapa,
                  clicavel: "",
                  etapas: _unref(etapas),
                  "indice-ativo": etapaAtiva.value,
                  largura: "50%"
                }, null, 8, ["etapas", "indice-ativo"])
              ]))
            : _createCommentVNode("", true),
          (etapaAtiva.value === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: _normalizeClass(["ODetalhesEventoPlanejado__PeriodoEProfissionais", !_unref(possuiSomenteUmProfissional) && '--ColunaInvertida'])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    (!_unref(possuiSomenteUmProfissional))
                      ? (_openBlock(), _createElementBlock("em", _hoisted_9))
                      : _createCommentVNode("", true),
                    _createVNode(_unref(OListaDeProfissionais), { profissionais: __props.profissionais }, null, 8, ["profissionais"])
                  ]),
                  (_unref(deveMostrarPeriodoPlanejado))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_unref(MEventoPeriodo), {
                            inicio: __props.inicio,
                            "rotulo-fim": _unref(t)('fim'),
                            "rotulo-inicio": _unref(t)('inicio')
                          }, null, 8, ["inicio", "rotulo-fim", "rotulo-inicio"]),
                          _createVNode(_unref(MEventoPeriodo), {
                            "atividade-recorrente": __props.atividadeRecorrente,
                            "bordar-translucida": true,
                            fim: __props.fim,
                            inicio: __props.inicioPlanejado
                          }, null, 8, ["atividade-recorrente", "fim", "inicio"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("em", {
                          class: _normalizeClass(["ODetalhesEventoPlanejado__Icone Icone--info pi pi-clock", 
                __props.atividadeRecorrente &&
                  'ODetalhesEventoPlanejado__Icone--AtividadeRecorrente'
              ])
                        }, null, 2),
                        _createVNode(_unref(MEventoPeriodo), {
                          "atividade-recorrente": __props.atividadeRecorrente,
                          fim: __props.fim,
                          inicio: __props.inicio,
                          "rotulo-fim": _unref(t)('fim'),
                          "rotulo-inicio": _unref(t)('inicio')
                        }, null, 8, ["atividade-recorrente", "fim", "inicio", "rotulo-fim", "rotulo-inicio"])
                      ]))
                ], 2),
                (__props.nomeProjeto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _hoisted_15,
                      _createTextVNode(" " + _toDisplayString(__props.nomeProjeto), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (etapaAtiva.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_unref(MFormularioAtividadeComAtributos), {
                  "atributos-esperados": __props.atributosEsperados,
                  "desabilitar-campos": _unref(deveDesabilitarCamposDeAtributos),
                  "lista-de-atributos-caracteristica-com-valor": __props.listaDeAtributosCaracteristicaComValor
                }, null, 8, ["atributos-esperados", "desabilitar-campos", "lista-de-atributos-caracteristica-com-valor"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_unref(deveMostrarBotaoDeAtividade))
        ? {
            name: "footer",
            fn: _withCtx(() => [
              (_unref(deveMostrarBotaoDeIniciarAtividadePlanejada))
                ? (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
                    key: 0,
                    onProximoPasso: avancarParaProximaEtapa,
                    "esta-carregando": false,
                    "fase-da-atividade": "proximoPasso"
                  }))
                : (_openBlock(), _createBlock(_unref(ABotaoDeAcao), {
                    key: 1,
                    onFinalizarAtividade: finalizarAtividadePlanejada,
                    onIniciarAtividade: iniciarAtividadePlanejada,
                    desabilitar: _unref(desabilitarBotaoIniciarAtividade),
                    "esta-carregando": estaIniciandoOuFinalizandoAtividade.value,
                    "fase-da-atividade": __props.faseDaAtividade
                  }, null, 8, ["desabilitar", "esta-carregando", "fase-da-atividade"]))
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["visible", "append-to", "class"]),
    (modalDeDelecaoEstaVisivel.value)
      ? (_openBlock(), _createBlock(_unref(MModalSeletorRadio), {
          key: 0,
          onAoAlterarVisibilidade: lidarComVisibilidadeModalDeDelecao,
          onAoClicarEmSubmeter: lidarComDelecaoAtividadePlanejada,
          "botoes-radio": _unref(opcoesSeletorDeDelecao),
          "esta-carregando": _unref(estaCarregandoDelecao),
          "mensagem-de-alerta": _unref(t)('aoDeletar'),
          "teleportar-para": __props.teleportarPara,
          "tipo-de-acao": "deletar",
          "titulo-cabecalho": _unref(t)('deletarAtividadePlanejada'),
          visibilidade: modalDeDelecaoEstaVisivel.value
        }, null, 8, ["botoes-radio", "esta-carregando", "mensagem-de-alerta", "teleportar-para", "titulo-cabecalho", "visibilidade"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})